import React, { forwardRef } from 'react';
import { Select, Option } from '@fiverr-private/forms';
import { Container } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';

interface OptionType {
  text: string;
  value: string;
}

interface FormSelectProps {
  placeholder?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  isRequired?: boolean;
  options?: OptionType[];
  disabled?: boolean;

  valid?: boolean;
  setValue?: (value: string) => void;
}

export const FormSelect = forwardRef<HTMLSelectElement, FormSelectProps>(
  (
    {
      placeholder,
      value,
      onChange,
      isRequired = false,
      options = [],
      disabled = false,

      valid: _valid,
      setValue: _setValue,
      ...rest
    },
    _ref
  ) => {
    // Adapter layer: Convert standard onChange to @fiverr-private/forms Select API
    const handleChange = (values: any) => {
      if (onChange && values && values.item) {
        const syntheticEvent = {
          target: {
            value: values.item,
          },
          currentTarget: {
            value: values.item,
          },
        } as React.ChangeEvent<HTMLSelectElement>;

        onChange(syntheticEvent);
      }
    };

    return (
      <Container paddingY="2" minHeight="68px" position="relative">
        {isRequired && (
          <Typography color="red_700" position="absolute" top="4px" right="8px" zIndex="2">
            *
          </Typography>
        )}

        <Select
          values={{ item: value || '' }}
          onChange={handleChange}
          disabled={disabled}
          placeholder={placeholder}
          fullWidth
          {...rest}
        >
          {options.map(({ text, value: optionValue }) => (
            <Option key={optionValue} value={optionValue}>
              {text}
            </Option>
          ))}
        </Select>
      </Container>
    );
  }
);

FormSelect.displayName = 'FormSelect';
